import {useEffect} from "react"

import {Main} from "./style"
import CardBeer from "../../components/CardBeer/index"

import Header from "../../components/Header/index"

import {IBeerProps} from "../../interfaces/index"

import {DeleteBeer} from "../../components/DeleteBeer/index"

import {useDashboardContext} from "../../providers/DashboardContext/index"


const Home = () => {

    const {beers, selectedBeers, selectedPartyType, getBeers, addBeer, deleteBeer} = useDashboardContext()

    useEffect(() => {
        getBeers()
    }, [])

    return (
        <>
            <Header/>
            
            <Main>
                <ul>
                    {
                        selectedPartyType === "None" ?
                        beers.map((currentBeer: IBeerProps, index: number) => (
                            <CardBeer key={index} beer={currentBeer} addBeer={addBeer}/>
                        ))
                        :
                        selectedBeers.filter(currentSelectedBeer => currentSelectedBeer.type === selectedPartyType).map((currentBeer, index) => (
                            <DeleteBeer key={index} beer={currentBeer} deleteBeer={deleteBeer}/>
                        ))
                    }
                </ul>
            </Main>
        </>
    )
}

export default Home